import {
  Map as FullwidthMap,
  type IMapCoordinates,
  type IMapFirstPaintOptions,
} from '@cian/frontend-newbuilding-map-component';
import {
  type IGeoObject,
  type TCustomBalloonFetchHtmlFunction,
  type TGeoObjectsFetchFunction,
} from '@cian/frontend-newbuilding-map-component/es/types';

import { type FC } from 'react';

import styles from './Map.css';

interface IMapProps {
  apiKey: string;
  onGeoObjectsFirstFetch: TGeoObjectsFetchFunction;
  onCustomBalloonHtmlFetch: TCustomBalloonFetchHtmlFunction;
  pinCoordinates: IMapCoordinates;
  zoom: number;
  currentTypes: string[];
  onGeoObjectClick?: (object: IGeoObject) => void;
  onBalloonOpen?: (object: IGeoObject) => void;
  onBalloonClose?: (object: IGeoObject) => void;
}

export const Map: FC<IMapProps> = props => {
  const {
    apiKey,
    onBalloonClose,
    onBalloonOpen,
    onCustomBalloonHtmlFetch,
    onGeoObjectClick,
    onGeoObjectsFirstFetch,
    pinCoordinates,
    zoom,
    currentTypes,
  } = props;

  const firstPaintOptions: IMapFirstPaintOptions = {
    apiKey,
    controls: [{ type: 'ZoomControl' }, { type: 'GeolocationControl' }, { type: 'FullscreenControl' }],
    fetch: {
      onCustomBalloonHtmlFetch,
      onGeoObjectsFetch: onGeoObjectsFirstFetch,
    },
    id: 'pik-map',
    onBalloonClose,
    onBalloonOpen,
    onGeoObjectClick,
    styles: { height: '100%', width: '100%' },
  };

  return (
    <section className={styles['map']} data-testid="pik-projects-map">
      <FullwidthMap
        firstPaintOptions={firstPaintOptions}
        geoObjectNames={currentTypes}
        media={[
          {
            maxWidth: Infinity,
            minWidth: -Infinity,
            options: {
              animationDuration: 300,
              center: pinCoordinates,
              defaultZoom: zoom,
              styles: { height: '100%', width: '100%' },
            },
          },
        ]}
      />
    </section>
  );
};
